import SolicitationDetail from './SolicitationDetail';

export default SolicitationDetail;



// WEBPACK FOOTER //
// ./src/pages/SolicitationDetail/index.jsx